import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../Translations';
import CompetencyFilterStore from './Store';
import ChevronDown from '../../../../../../../Cutesies/ChevronDown';

interface Props {
  competencyFilterStore: CompetencyFilterStore;
}

const selectedCompetencyValuesLength = (competencyFilterStore: CompetencyFilterStore) =>
  competencyFilterStore.state.filter.competencies.length;

const whenNotAllCompetenciesSelected = (competencyFilterStore: CompetencyFilterStore) =>
  when(
    selectedCompetencyValuesLength(competencyFilterStore) <
      competencyFilterStore.initialFilterValues.competencies.length,
    {},
  );

const FilterButtonText: React.FC<Props> = ({ competencyFilterStore }) =>
  whenNotAllCompetenciesSelected(competencyFilterStore)
    .map(() => (
      <div className="flex flex-row justify-between w-full">
        <T
          kind="Selected: ({{count}})"
          count={selectedCompetencyValuesLength(competencyFilterStore)}
        />
        <div className="w-5">
          <ChevronDown />
        </div>
      </div>
    ))
    .getOrElse(() => (
      <div className="flex flex-row justify-between w-full">
        <T kind={'Competency'} />
        <div className="w-5">
          <ChevronDown />
        </div>
      </div>
    ));

export default observer(FilterButtonText);
